"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _LanguageProvider = require("../common/LanguageProvider");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _CookieAgreementsProvider = require("../common/CookieAgreementsProvider");
var _AccountProvider = require("./AccountProvider");
var _isSalesmanagoEnabled = _interopRequireDefault(require("@deosite/helpers/isSalesmanagoEnabled"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSalesmanago = function useSalesmanago() {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData;
  var domains = global.__appConfig__.domainLanguages;
  var domain = Object.keys(domains).find(function (key) {
    return domains[key] === language.language;
  });
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var translations = {
    purchase: (0, _langLibrary["default"])("Products purchase"),
    shoppingCart: (0, _langLibrary["default"])("Change in the shopping cart"),
    visitUrl: (0, _langLibrary["default"])("Url changed"),
    action: (0, _langLibrary["default"])("Action performed"),
    visitProduct: (0, _langLibrary["default"])("Visit to the product page"),
    logIn: (0, _langLibrary["default"])("User logged in"),
    transaction: (0, _langLibrary["default"])("Checkout started")
  };
  var timestamp = new Date().getTime();
  var handleSalesmanagoEvent = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(type, additionalData) {
      var _accountData$customer, _additionalData$detai, _additionalData$detai2, _additionalData$detai3;
      var smClient, userId, contactData, baseEventData, products, additionalEventData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!(0, _isSalesmanagoEnabled["default"])({
                language: language.language
              }) || !cookieAgreements.salesmanago)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              smClient = _jsCookie["default"].get("smclient");
              userId = smClient ? {
                contactId: smClient,
                email: null
              } : accountData !== null && accountData !== void 0 && accountData.email ? {
                email: accountData === null || accountData === void 0 ? void 0 : (_accountData$customer = accountData.customer) === null || _accountData$customer === void 0 ? void 0 : _accountData$customer.email,
                contactId: null
              } : {
                email: additionalData === null || additionalData === void 0 ? void 0 : additionalData.email,
                contactId: null
              };
              if (Object.values(userId).some(function (value) {
                return value;
              })) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              contactData = _objectSpread({}, userId);
              baseEventData = {
                date: timestamp,
                location: language.language,
                contactExtEventType: type,
                detail1: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[0]) !== null && _additionalData$detai !== void 0 ? _additionalData$detai : null : null,
                detail2: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai2 = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[1]) !== null && _additionalData$detai2 !== void 0 ? _additionalData$detai2 : null : null,
                detail3: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai3 = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[2]) !== null && _additionalData$detai3 !== void 0 ? _additionalData$detai3 : null : null,
                shopDomain: domain
              };
              products = "";
              if ((additionalData === null || additionalData === void 0 ? void 0 : additionalData.products) !== undefined) {
                additionalData.products.forEach(function (product, index) {
                  products += product;
                  products += additionalData.products.length === index + 1 ? "" : ",";
                });
              }
              if (!(type in ["PURCHASE", "CART", "OFFER"])) {
                _context.next = 13;
                break;
              }
              if (!(products.length === 0 || additionalData.value === undefined)) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              _context.t0 = type;
              _context.next = _context.t0 === "PURCHASE" ? 16 : _context.t0 === "CART" ? 18 : _context.t0 === "VISIT" ? 20 : _context.t0 === "OTHER" ? 22 : _context.t0 === "OFFER" ? 24 : _context.t0 === "LOGIN" ? 26 : _context.t0 === "TRANSACTION" ? 28 : 30;
              break;
            case 16:
              additionalEventData = {
                description: translations.purchase,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 18:
              additionalEventData = {
                description: translations.shoppingCart,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 20:
              additionalEventData = {
                description: translations.visitUrl
              };
              return _context.abrupt("break", 31);
            case 22:
              additionalEventData = {
                description: translations.action
              };
              return _context.abrupt("break", 31);
            case 24:
              additionalEventData = {
                description: translations.visitProduct,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 26:
              additionalEventData = {
                description: translations.logIn
              };
              return _context.abrupt("break", 31);
            case 28:
              additionalEventData = {
                description: translations.purchase
              };
              return _context.abrupt("break", 31);
            case 30:
              return _context.abrupt("break", 31);
            case 31:
              _context.prev = 31;
              _context.next = 34;
              return _agent.requests.postExternal("".concat(global.__appConfig__.salesmanagoApiAddContact), _objectSpread(_objectSpread({}, contactData), {}, {
                contactEvent: _objectSpread(_objectSpread({}, baseEventData), additionalEventData)
              }));
            case 34:
              _context.next = 40;
              break;
            case 36:
              _context.prev = 36;
              _context.t1 = _context["catch"](31);
              console.log(_context.t1);
              return _context.abrupt("return", false);
            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[31, 36]]);
    }));
    return function handleSalesmanagoEvent(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return handleSalesmanagoEvent;
};
var _default = useSalesmanago;
exports["default"] = _default;